//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require("vue2-scrollbar/dist/style/vue2-scrollbar.css")
export default {
  props: {
    myProfileData: {
      type: Object,
      require: true,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  computed: {
    complitedAchievements() {
      return this.myProfileData.progresses.filter(elem => elem.dateAccepted)
    },
    closedAchievements() {
      return this.myProfileData.progresses.filter(elem => !elem.dateAccepted)
    }
  },
  methods: {
    pictureUrl (url) {
      return this.$absoluteImageUrl(url)
    }
  }
}
